
import { Injectable } from '@angular/core';

import { ActionHandler } from '@app/core/components/actions/action.handler';

@Injectable()
export class MasterConsultaFundosActions {
    constructor(
        private actionHandler: ActionHandler,
        
    ) {}



}